var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingFlag,
          expression: "loadingFlag",
        },
      ],
      attrs: {
        title: "支付宝收款账号维护",
        visible: _vm.dialogVisible,
        "before-close": _vm.closeDialog,
        "append-to-body": "",
        width: "600px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "tip-box" }, [
          _c("img", {
            staticClass: "icon-24-warning",
            attrs: {
              src: require("@/assets/images/icon/warning_icon.png"),
              alt: "",
            },
          }),
          _vm._v("请确认实名信息"),
        ]),
        _c("div", [
          _c("div", { staticClass: "content-txt" }, [
            _vm._v(
              "为保障返佣金额正常打款，请维护当前客户管家登录账号的实名信息对应的支付宝实名账号。"
            ),
          ]),
          _c("div", { staticClass: "content-txt y-mt-10" }, [
            _vm._v("当前账号实名信息："),
          ]),
          _vm.realNameId
            ? _c("div", { staticClass: "real-name-box y-mt-10" }, [
                _c("span", { staticClass: "realname" }, [
                  _vm._v(_vm._s(_vm.isRealNameInfo.cerName)),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "systemColor y-c-p look-content",
                    on: { click: _vm.openRealNameFn },
                  },
                  [_vm._v("查看实名")]
                ),
              ])
            : _vm._e(),
          !_vm.realNameId
            ? _c("div", { staticClass: "no-real-name-box y-mt-10" }, [
                _c("span", { staticClass: "realname" }, [_vm._v("未实名")]),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.realNameId
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goOpenAliDialog },
                },
                [_vm._v("实名正确，去绑定支付宝账号")]
              )
            : _vm._e(),
          !_vm.realNameId
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.openRealNameFn },
                },
                [_vm._v("立即实名")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }